<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Vehicle condition">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="vCondition">Condition</label>
              <input type="text" 
              class="form-control" 
              id="vCondition" 
              placeholder="Condition"
              v-model="vCondition">
              <div class="invalid-feedback" v-if="errors.vCondition">{{ errors.vCondition[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as vehicleConditionService from '../../services/vehicleCondition.service';
    export default {
        name:"ModalVehicleConditionEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                vCondition:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettVehicleConditionAll']),
        },
        methods:{
            ...mapActions(['fetchVehicleConditionAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.vCondition = props.rowData.vCondition;
            },

            fnUpdate:async function(){
                const obj = {
                    "vCondition":this.vCondition,
                    "status":this.status
                }

                try{
                    await vehicleConditionService.update(this.id, obj);
                    this.fetchVehicleConditionAll();
                    messageService.fnSweetAlertSuccessToast('Vehicle condition', 'Updated successfully ');

                    this.id = ''; 
                    this.vCondition = '';
                    this.status ='';

                    this.hideModal();

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Vehicle category - update', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Vehicle category - update', 'Something wrong');
                        break;
                    }

                }
            }
        }
    }
</script>